import { Icd10CodeType } from '~/services/api/enums';
import { ICarePlanIcd10Code } from '~/services/api/carePlanIcd10Codes/types';

const getInitialValues = (carePlanIcd10Code: ICarePlanIcd10Code) => ({
  ...carePlanIcd10Code,
  id: carePlanIcd10Code.id ?? 0,
  typeId: carePlanIcd10Code.typeId ?? Icd10CodeType.Primary,
  icd10CodeId: carePlanIcd10Code.icd10CodeId ?? null,
});

export default getInitialValues;
